import React, { useEffect, useState } from 'react';

export type IframeWithConsentProps = {
  url: string;
  title?: string;
};

const IframeWithConsent: React.FC<IframeWithConsentProps> = ({
  url,
  title,
}) => {
  const [applyIframe, setApplyIframe] = useState<boolean>(false);

  useEffect((): void => {
    // Wait until CCM19 is loaded in the browser before
    // adding the iframe's markup
    if (!window.CCM) return;
    setApplyIframe(true);
  }, []);

  return applyIframe ? (
    <iframe
      width="100%"
      height="100%"
      src={url}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={title ?? ''}
      loading="lazy"
    />
  ) : (
    //CCM19 will show an image of the video if the user has not accepted the cookies
    <p className="hidden">IframeNotAvailable</p>
  );
};

export default IframeWithConsent;
